import { createPersistedStore } from '@/meta/persistedStore';

// В сторадже лежит ГОЛЫЙ uuid без JSON-кавычек — формат исторический, менять
// нельзя: перегенерация id порвала бы сшивку аналитики существующих устройств.
const encodeRaw = (id: string) => id;

let lastId: string | null = null; // fallback: localStorage недоступен (private mode)
let generated = false; // sanitize создал/восстановил id — его надо дозаписать

function sanitize(raw: unknown): string {
  if (typeof raw === 'string' && raw) return raw;
  generated = true;
  // после clear() другой вкладки восстанавливаем прежний id, а не плодим новый
  return lastId ?? crypto.randomUUID();
}

const store = createPersistedStore<string>('dg_anon_id', sanitize, {
  encode: encodeRaw,
  decode: encodeRaw,
});

// Стабильный per-устройство аноним-id для заголовка X-Anon-Id (сшивка аналитики §7/§2.9).
// Без стораджа деградирует до per-сессии — сшивка хуже, но ничего не падает.
export function getAnonId(): string {
  // старый контракт: каждый вызов перечитывает сторадж (ключ пишут напрямую
  // соседние вкладки и тесты) — кэш фабрики здесь только смягчает недоступность
  store.invalidate();
  const id = store.get();
  lastId = id;
  if (generated) {
    generated = false;
    store.set(id); // best-effort запись свежесгенерённого id в localStorage
  }
  return id;
}
